import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(props, _ref) {
    var $, $f7, $update, marketplace, mp, user, institutions, selectedItem, header_html, iab, learnMore, addInstitution, marketplaceAdd, marketplaceReplace, deleteMP;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            $ = _ref.$, $f7 = _ref.$f7, $update = _ref.$update;
            _context4.next = 3;
            return myApp.getMarketplace();

          case 3:
            marketplace = _context4.sent;
            mp = [];
            _context4.next = 7;
            return myApp.user();

          case 7:
            user = _context4.sent;
            _context4.next = 10;
            return myApp.server.getJSON('institutions');

          case 10:
            institutions = _context4.sent;
            selectedItem = {};
            user.data.marketplace = user.data.marketplace || [];
            console.log(marketplace, 'Marketplace');
            console.log(user.data.marketplace, 'user.data.marketplace');
            console.log(institutions);
            header_html = {
              it: '<div class="margin-bottom-half">\
            Aziende/Associazioni che sono collegabili <span class="text-color-secondary text-bold">gratuitamente</span> a Doctorpass.\
          </div>\
          <div class="margin-bottom-half">\
            L\'utente può decidere di scegliere e associare alla App una o più (fino a 5)\
            <span class="text-color-secondary text-bold"> per usufruire delle informazioni e dei vantaggi </span> che queste offrono.\
          </div>\
          <div class="margin-bottom-half">Dalla sesta scelta sarà necessario effettuare una sostituzione.</div>\
          <div>\
            L\'integrazione del servizio si può effettuare semplicemente  toccando il tasto \
            <span class="text-color-primary text-bold"> "AGGIUNGI  SERVIZIO".</span>\
          </div>',
              en: '<div class="margin-bottom-half">' + 'Companies / Associations that can be connected <span class="text-color-secondary text-bold"> for free </span> to Doctorpass. ' + '</div>' + '<div class="margin-bottom-half"> ' + '  The user can decide to choose and associate one or more (up to 5) to the App ' + ' <span class="text-color-secondary text-bold"> to take advantage of the information and benefits </span> they offer. ' + '</div> ' + '<div class="margin-bottom-half"> From the sixth choice it will be necessary to make a substitution. </div> ' + '<div> ' + ' The integration of the service can be carried out simply by touching the key ' + ' <span class = "text-color-primary text-bold"> "ADD SERVICE". </span> ' + '</div>',
              fr: '<div class="margin-bottom-half"> \
             Entreprises / Associations pouvant être connectées <span class="text-color-secondary text-bold"> gratuitement </span> à Doctorpass.\
           </div> \
           <div class="margin-bottom-half"> \
             L\'utilisateur peut décider d\'en choisir et d\'en associer une ou plusieurs (jusqu\'à 5) à l\'App \
             <span class="text-color-secondary text-bold"> pour profiter des informations et des avantages </span> qu\'ils offrent. \
           </div> \
           <div class="margin-bottom-half"> A partir du sixième choix il faudra faire une substitution. </div>\
           <div> \
             L\'intégration du service peut être effectuée simplement en appuyant sur la touche \
             <span class="text-color-primary text-bold"> "AJOUTER UN SERVICE". </span> \
           </div>',
              es: '<div clase="margin-bottom-half"> \
             Empresas/Asociaciones que pueden conectarse <span class="text-color-secundary text-bold"> de forma gratuita </span> a Doctorpass.\
           </div> \
           <div clase="margin-bottom-half"> \
             El usuario puede decidir elegir y asociar uno o más (hasta 5) a la App \
             <span class="text-color-secundary text-bold"> para aprovechar la información y los beneficios </span> que ofrecen. \
           </div> \
           <div class="margin-bottom-half"> A partir de la sexta elección será necesario realizar una sustitución. </div> \
           <div> \
             La integración del servicio se puede realizar simplemente tocando la tecla \
             <span class="text-color-primary text-bold"> "AGREGAR SERVICIO".</span> \
           </div>',
              de: '<div class="margin-bottom-half">' + 'Unternehmen / Vereine, die <span class="text-color-secondary text-bold"> kostenlos </span> an Doctorpass angeschlossen werden können. ' + '</div> ' + '<div class="margin-bottom-half"> ' + '  Der Benutzer kann entscheiden, eine oder mehrere (bis zu 5) auszuwählen und der App zuzuordnen ' + '  <span class="text-color-secondary text-bold"> , um die angebotenen Informationen und Vorteile zu nutzen </span> . ' + '</div> ' + '<div class="margin-bottom-half"> Ab der sechsten Wahl muss eine Ersetzung vorgenommen werden. </div> ' + '<div> ' + '  Die Einbindung des Dienstes erfolgt einfach durch Berühren der Taste ' + ' <span class="text-color-primary text-bold"> "DIENST HINZUFÜGEN". </span> ' + '</div>'
            };

            iab = function iab(ev) {
              var href = $(ev.target).data('href');
              myApp.iab(href, '_system');
            };

            learnMore = function learnMore(ev) {
              selectedItem = marketplace.find(function (item) {
                return item.id == $(ev.target).data('id');
              });
              $update();
              $f7.popup.open('.popup-marketplace');
            };

            addInstitution = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(evt) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        console.log(evt.target.dataset.id);
                        user.data.institutions = user.data.institutions || [];
                        user.data.institutions = user.data.institutions.filter(function (item) {
                          return item;
                        });

                        if (!user.data.institutions.find(function (item) {
                          return item.name == evt.target.dataset.id;
                        })) {
                          _context.next = 5;
                          break;
                        }

                        return _context.abrupt("return", $f7.dialog.alert(lng.serviceAlreadyActive));

                      case 5:
                        user.data.institutions.push(institutions.find(function (item) {
                          return item.name == evt.target.dataset.id;
                        }));
                        _context.next = 8;
                        return myApp.server.postJSON('institutions', user.data.institutions);

                      case 8:
                        $f7.toastSuccess(lng.service_added);
                        _context.next = 11;
                        return myApp.user(user);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function addInstitution(_x3) {
                return _ref3.apply(this, arguments);
              };
            }();

            marketplaceAdd = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var new_mp;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        user.data.marketplace = user.data.marketplace || [];
                        user.data.marketplace = user.data.marketplace.filter(function (item) {
                          return _typeof(item) === 'object' && item.length;
                        });

                        if (!user.data.marketplace.find(function (item) {
                          return item.marketplace.href == selectedItem.href;
                        })) {
                          _context2.next = 4;
                          break;
                        }

                        return _context2.abrupt("return", $f7.dialog.alert(lng.serviceAlreadyActive));

                      case 4:
                        _context2.prev = 4;

                        if (!(user.data.marketplace.length >= 5)) {
                          _context2.next = 8;
                          break;
                        }

                        _context2.next = 8;
                        return marketplaceReplace();

                      case 8:
                        $f7.preloader.show();
                        _context2.next = 11;
                        return myApp.server.postJSON('marketplace', selectedItem);

                      case 11:
                        new_mp = _context2.sent;
                        user.data.marketplace = new_mp;
                        _context2.next = 15;
                        return myApp.user(user);

                      case 15:
                        $f7.popup.close();
                        $f7.toastSuccess(lng.service_added);
                        _context2.next = 22;
                        break;

                      case 19:
                        _context2.prev = 19;
                        _context2.t0 = _context2["catch"](4);
                        $f7.alertError(_context2.t0);

                      case 22:
                        _context2.prev = 22;
                        $f7.preloader.hide();
                        $update();
                        return _context2.finish(22);

                      case 26:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[4, 19, 22, 26]]);
              }));

              return function marketplaceAdd() {
                return _ref4.apply(this, arguments);
              };
            }();

            marketplaceReplace = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // controlla company-type
                        console.log(selectedItem); // filtra marketplace con elementi cancellabili

                        if (selectedItem.company_type !== 'GOLD') {
                          mp = user.data.marketplace.filter(function (item) {
                            return item.company_type !== 'GOLD';
                          });
                        } else {
                          mp = _toConsumableArray(user.data.marketplace);
                        }

                        if (!(mp.length >= 5 && false)) {
                          _context3.next = 6;
                          break;
                        }

                        return _context3.abrupt("return", Promise.reject({
                          message: lng.services_gold_only
                        }));

                      case 6:
                        _context3.next = 8;
                        return $update();

                      case 8:
                        console.log(mp);
                        return _context3.abrupt("return", new Promise(function (resolve, reject) {
                          var popup = $f7.popup.create({
                            el: '.popup-delete-mp'
                          });
                          popup.open();
                        }));

                      case 10:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function marketplaceReplace() {
                return _ref5.apply(this, arguments);
              };
            }();

            deleteMP = function deleteMP(ev) {
              $f7.dialog.confirm('<strong>' + $(ev.target).data('caption') + '</strong><br>' + lng.marketplace_delete_service_message, function () {
                var idx = $(ev.target).data('id') * 1;
                myApp.server.deleteJSON('marketplace/' + $(ev.target).data('id')).then(function (res) {
                  user.data.marketplace = res;
                  return myApp.user(user);
                }).then(function () {
                  return $f7.popup.close('.popup-delete-mp');
                }).then(function () {
                  return $update();
                });
                ;
              });
            };

            return _context4.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="marketplace">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">${lng.marketplace_explore}</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll">
      <div style="max-width: 550px; margin: auto">

        <h2 class="text-align-center">Istituzioni e Amministrazioni</h2>
        <hr class="sep" />

        ${institutions.map((item) => $h`
        <div class="block row">
          <div class="col-33">
            <img width="100%" src="${item.logo}" alt=""/>
          </div>
          <div class="col-66">
            <h3 class="text-color-secondary">
              ${item.title}
            </h3>
            <a href="#" @click=${addInstitution} data-id="${item.name}" class="text-bold text-upper">${lng.marketplace_add}</a>
          </div>
          <div class="col">
            ${item.text}
          </div>
        </div>
        <hr class="sep" />
        `)}

        <div class="block" innerHTML=${header_html[lng.key]}></div>

        <hr class="sep" />

        ${marketplace.length === 0 ? $h`
        <div class="block">
          <img width="100%" src="static/gift.svg"/>
          <h4 innerHTML=${lng.noMarketplaceMessage}></h4>
        </div>
        `:''}

        ${marketplace.map((item) => $h`
        <div class="marketplace-${
               item.type
             }">
          <h3>${item.caption} <span class="marketplace-company-type">${item.company_type}</span></h3>
          <img src="${item.src}" />
          <div>
            <div style="font-size:1.2em">${item.description}</div>

            <button @click=${learnMore} 
                     data-id="${item.id}" 
                     class="button color-secondary button-inline">${lng.learn_more}</button>
          </div>
        </div>
        `)}

      </div>
    </div>

    <div class="popup popup-marketplace overflow-auto">

      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Marketplace</div>
              <div class="right">
                <a class="link popup-close"><i class="f7-icons">xmark_circle_fill</i></a>
              </div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">
              <h1>${selectedItem.caption} <span class="marketplace-company-type">${selectedItem.company_type}</span></h1>
              <img src="${selectedItem.src}" width="100%" />
              <div>
                <blockquote> ${selectedItem.description}</blockquote>
              </div>
              <div class="margin-bottom" innerHTML=${selectedItem.text}></div>
              ${selectedItem.href && $h`
              <button 
                class="button button-large button-outline button-round color-primary margin-bottom-half"
                data-href="${selectedItem.href}" 
                @click=${iab}>${lng.visit_website}</button>
              `}
              <button @click=${marketplaceAdd} 
                       data-id="${selectedItem.id}" 
                       class="button button-large button-fill button-round color-secondary">${lng.marketplace_add}</button>

              <button class="margin-top button button-large button-fill button-round color-black popup-close">${lng.close}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup popup-delete-mp">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Marketplace</div>
              <div class="right">
                <a class="link popup-close"><i class="f7-icons">xmark_circle_fill</i></a>
              </div>
            </div>
          </div>
          <div class="page-content">
            <div class="block text-align-center">
              <h4 innerHTML=${lng.marketplace_max_items_message}></h4>
            </div>
            <div class="list no-hairlines">
              <ul>
                ${mp.map((item, idx) => $h`
                <li>
                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title">
                        ${item.marketplace.caption}
                      </div>
                      <div class="item-after text-color-red" @click=${deleteMP} data-caption="${item.marketplace.caption}" data-id="${idx}">
                        ${lng.marketplace_delete_service}
                      </div>
                    </div>
                  </div>
                </li>
                `)}
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
`
    }
    );

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();